import {
  GET_RUNS_REQUEST,
  GET_RUNS_SUCCESS,
  GET_RUNS_FAILURE
} from '../../../actions/api/runs';
import {
  RUNLIST_INITIALIZE,
  SET_ACTIVE_RUNLIST_FILTER,
  SET_ACTIVE_RUNLIST_GROUPING,
  SET_ACTIVE_RUNLIST_SORTING,
  SET_USER_ONLY_RUNS
} from '../../../actions/page/run/RunList';

export default function RunList(state = { fetchedAllRuns: false }, action) {
  switch (action.type) {
    case RUNLIST_INITIALIZE:
      const defaults = {
        activeFilter: { value: 'running', name: 'Active Routines' },
        activeGrouping: { value: '*', name: 'No Grouping' },
        activeSorting: { value: '*', name: 'Sort By' },
        ready: false,
        userIsAdmin: false,
        userOnlyRuns: true
      };
      return {
        ...state,
        ...defaults
      };
    case GET_RUNS_REQUEST:
      return {
        ...state,
        ready: false
      };
    case GET_RUNS_SUCCESS:
      let fetchedAllRuns = state.fetchedAllRuns;
      if (action.payload.url.slice(-3) === 'all') {
        fetchedAllRuns = true;
      }
      return {
        ...state,
        ready: true,
        fetchedAllRuns
      };
    case GET_RUNS_FAILURE:
      return {
        ...state,
        ready: true
      };
    case SET_ACTIVE_RUNLIST_FILTER:
      return {
        ...state,
        activeFilter: action.filter
      };
    case SET_ACTIVE_RUNLIST_GROUPING:
      return {
        ...state,
        activeGrouping: action.grouping
      };
    case SET_ACTIVE_RUNLIST_SORTING:
      return {
        ...state,
        activeSorting: action.sorting
      };
    case SET_USER_ONLY_RUNS:
      return {
        ...state,
        userOnlyRuns: action.setting
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/Run/RunList.js